/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-06-13 13:07:17
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-01 15:55:03
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\routes\cuser.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  // 对外开放页面
  {
    path: '/open',
    component: () => import('@/components/frame/FrameMainRouter.vue'),
    redirect: '/open/scene',
    children: [
      // 场景体验
      {
        path: 'scene',
        name: 'open-scene',
        component: () => import('@/views/open/scene.vue'),
        meta: {
          title: '应用场景体验',
          // public: true,
          noPadding: true,
        },
      },
    ],
  },
  {
    path: '/open/share/:shareCode',
    name: 'open-share',
    component: () => import('@/views/open/share.vue'),
    meta: {
      title: '应用场景分享',
      public: true,
    },
  },
  {
    path: '/cuserLogin',
    name: 'cuser-login',
    component: () => import('@/views/Common/CLogin.vue'),
    meta: {
      public: true,
    },
  },
];
